import React from 'react'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Tooltip from 'react-bootstrap/Tooltip'

export class ChartHeader extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
    }
  }

  formatPercent = percent => {
    const sign = this.props.growthCat === 'UP' ? '+' : ''
    return sign + Math.round(percent).toString() + '%'
  }

  render() {

    return (
      <>
        <Row className='chart-top'>
          <Col xs={9} className='name-col'>
              <p className='chart-name'>
                {this.props.name}
              </p>
          </Col>
          <div className='float'>
            <OverlayTrigger
              placement={'bottom'}
              overlay={
                <Tooltip id='percent-tooltip'>
                  This graph shows 3 years of data for context. The percent change shows change over the past 30 days.
                </Tooltip>
              }
            >
              <span className={this.props.growthCat === 'UP' ? 'percent up' : 'percent down'}>
                {this.formatPercent(this.props.percent)}
              </span>
            </OverlayTrigger>
          </div>
        </Row>
        <Row className='second-row'>
          {
            this.props.description!== undefined && this.props.description.length > 0 &&
            <Col>
              <OverlayTrigger
                placement={'right'}
                className={'tooltip'}
                overlay={
                  <Tooltip id='spike-tooltip'>
                    {this.props.description}
                  </Tooltip>
                }
              >
                <p className='why'>Why the spike?</p>
              </OverlayTrigger>
            </Col>
          }
        </Row>
      </>
    )
  }
}